import { FormButton } from 'common/components';
import { FileImageOutlined } from '@ant-design/icons';

const ButtonAddImageUrl = (props) => {
  const { onClick, multiple = false } = props;

  return (
    <FormButton
      icon={<FileImageOutlined />}
      text={
        multiple
          ? 'Click here to select multiple image URLs'
          : 'Click here to select one image URL'
      }
      style={{ width: '100%' }}
      onClick={onClick}
    ></FormButton>
  );
};

export default ButtonAddImageUrl;
